import React, { useState } from "react";
import AutorenewIcon from "@mui/icons-material/Autorenew";
import Tooltip from "@mui/material/Tooltip";

interface RegeneratingIconProps {
  disabled?: boolean;
}

const RegeneratingIcon: React.FC<RegeneratingIconProps> = ({ disabled = false }) => {
  const [spinning, setSpinning] = useState(false);

  const handleClick = () => {
    if (disabled) return;
    setSpinning(true);
    setTimeout(() => setSpinning(false), 600);
  };

  return (
    <Tooltip title="Regenerate SOA">
      <div
        onClick={handleClick}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "8px",
          cursor: disabled ? "not-allowed" : "pointer",
        }}
      >
        <AutorenewIcon
          sx={{
              color: disabled ? "#ededede" : "#A39455",
            fontSize: 24,
            animation: spinning && !disabled ? "spin 0.6s linear" : "none",
            "@keyframes spin": {
              "0%": {
                transform: "rotate(0deg)",
              },
              "100%": {
                transform: "rotate(360deg)",
              },
            },
          }}
        />
      </div>
    </Tooltip>
  );
};

export default RegeneratingIcon;